import React from 'react'
import { Row, Col, Table } from 'antd'
import { IconHelper } from '../../helpers'
import { isEmpty, get } from 'lodash'
import { translate } from 'react-i18next'
import moment from 'moment'

const TableDetail = ({ t, paymentHistoryList }) => {
    const { IconSand, IconArrowDown, IconArrowRight } = IconHelper
    const language = localStorage.getItem('i18nextLng')

    const columns = [
        {
            title: t("payment_history.plan"),
            dataIndex: 'plan',
            key: 'plan',
            render: (text, data) => (
                <span>{get(data, `description.${language}.packageName`, '')}</span>
            )
        },
        {
            title: t('payment_history.price'),
            dataIndex: 'paymentAmt',
            key: 'paymentAmt',
            render: (text) => (
                <span>{text}</span>
            )
        },
        {
            title: t("payment_history.due_date"),
            dataIndex: 'dueDate',
            key: 'dueDate',
            render: (text) => (
                <span>
                    {moment(text)
                        .add(language === 'th' ? 543 : 0, "year")
                        .format('DD/MM/Y')}
                </span>
            )
        },
        {
            title: t("payment_history.exp_date"),
            dataIndex: 'expDate',
            key: 'expDate',
            render: (text, data) => (
                <span>
                    {moment(get(data, 'chargeNotifyRequest.subscription-result.data.next-cycle-date', ''))
                        .add(1, "days").add(language === 'th' ? 543 : 0, "year")
                        .format('DD/MM/Y')}
                </span>
            )
        },
        {
            title: t("payment_history.status"),
            dataIndex: 'status',
            key: 'status',
            width: '90px',
            render: (text, data) => {
                if (data.status === 'paid')
                    return (<span style={{ color: '#27AE60' }}>{t("payment_history.status_success")}</span>)
                if (data.status === 'fail')
                    return (<span style={{ color: '#FF0000' }}>{t("payment_history.status_fail")}</span>)
            },
        },
    ];
    const locale = {
        emptyText: (
            <div>
                <IconSand />
                <div><span>{t("payment_history.empty")}</span></div>
            </div>
        )
    }
    const customExpandIcon = (props) => {
        if (props.expanded) {
            return (
                <IconArrowDown onClick={e => {
                    props.onExpand(props.record, e);
                }} />
            );
        } else {
            return (
                <IconArrowRight onClick={e => {
                    props.onExpand(props.record, e);
                }} />
            );
        }
    }
    return (
        !isEmpty(paymentHistoryList)
            ? <Table
                pagination={{ pageSize: 15 }}
                bordered={false} size="middle"
                locale={locale}
                dataSource={paymentHistoryList}
                columns={columns}
                expandIcon={(props) => customExpandIcon(props)}
                expandedRowRender={expense => (
                    <div className="payment-detail">
                        <Row>
                            <Col span={7}>
                                <span><label>{t("payment_history.transaction_id")}</label>&nbsp;:</span>
                            </Col>
                            <Col span={17}>
                                <span>{expense['payment-ref']}</span>
                            </Col>
                        </Row><br />
                        <Row>
                            <Col span={7}>
                                <span><label>{t("payment_history.payment_method")}</label>&nbsp;:</span>
                            </Col>
                            <Col span={17}>
                                <span>{expense['chargeNotifyRequest']['charge-result'].data['payment-channel'] === 'tw' ? t("payment_history.tw") : t("payment_history.cc")}</span>
                            </Col>
                        </Row>
                    </div>
                )}
                expandIconColumnIndex={5}
                rowKey='id'
                style={{ cursor: 'pointer' }}
                expandRowByClick />
            : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <IconSand />
                <div><span>{t("payment_history.empty")}</span></div>
            </div>
    )
}

export default translate()(TableDetail)